// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var DOM_HTML_Indexed_InputType = require("../DOM.HTML.Indexed.InputType/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Formless_Class_Initial = require("../Formless.Class.Initial/index.js");
var Formless_Component = require("../Formless.Component/index.js");
var Formless_Internal_Transform = require("../Formless.Internal.Transform/index.js");
var Formless_Query = require("../Formless.Query/index.js");
var Formless_Transform_Record = require("../Formless.Transform.Record/index.js");
var Formless_Transform_Row = require("../Formless.Transform.Row/index.js");
var Formless_Types_Component = require("../Formless.Types.Component/index.js");
var Formless_Types_Form = require("../Formless.Types.Form/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Heterogeneous_Mapping = require("../Heterogeneous.Mapping/index.js");
var Lunarbox_Capability_Navigate = require("../Lunarbox.Capability.Navigate/index.js");
var Lunarbox_Capability_Resource_User = require("../Lunarbox.Capability.Resource.User/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Lunarbox_Form_Field = require("../Lunarbox.Form.Field/index.js");
var Lunarbox_Form_Validation = require("../Lunarbox.Form.Validation/index.js");
var Lunarbox_Page_FormPage = require("../Lunarbox.Page.FormPage/index.js");
var LoginForm = function (x) {
    return x;
};
var SetLoginError = (function () {
    function SetLoginError(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SetLoginError.create = function (value0) {
        return function (value1) {
            return new SetLoginError(value0, value1);
        };
    };
    return SetLoginError;
})();
var HandleLoginForm = (function () {
    function HandleLoginForm(value0) {
        this.value0 = value0;
    };
    HandleLoginForm.create = function (value0) {
        return new HandleLoginForm(value0);
    };
    return HandleLoginForm;
})();
var ToRegister = (function () {
    function ToRegister() {

    };
    ToRegister.value = new ToRegister();
    return ToRegister;
})();
var newtypeLoginForm = new Data_Newtype.Newtype(function (n) {
    return n;
}, LoginForm);
var functorFormQuery = new Data_Functor.Functor(function (f) {
    return function (m) {
        return new SetLoginError(m.value0, f(m.value1));
    };
});
var formComponent = function (dictMonadAff) {
    var proxies = Formless_Transform_Row.mkSProxies()(newtypeLoginForm)(Formless_Transform_Row.makeSProxiesCons(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))()(Formless_Transform_Row.makeSProxiesCons(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))()(Formless_Transform_Row.makeSProxiesNil)))(Formless_Types_Form.FormProxy.value);
    var render = function (v) {
        return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("form") ])([ Lunarbox_Component_Utils.maybeElement(v.loginError)(function (err) {
            return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("form__message form__message--error ") ])([ Halogen_HTML_Core.text(err) ]);
        }), Halogen_HTML_Elements.div_([ Lunarbox_Form_Field.input(new Data_Symbol.IsSymbol(function () {
            return "email";
        }))(newtypeLoginForm)(newtypeLoginForm)()()(proxies.email)(v.form)([ Halogen_HTML_Properties.placeholder("Email"), Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputEmail.value) ]), Lunarbox_Form_Field.input(new Data_Symbol.IsSymbol(function () {
            return "password";
        }))(newtypeLoginForm)(newtypeLoginForm)()()(proxies.password)(v.form)([ Halogen_HTML_Properties.placeholder("Password"), Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputPassword.value) ]), Lunarbox_Form_Field.submit("Log in") ]) ]);
    };
    var handleQuery = function (v) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
            var $28 = {};
            for (var $29 in v1) {
                if ({}.hasOwnProperty.call(v1, $29)) {
                    $28[$29] = v1[$29];
                };
            };
            $28.loginError = v.value0;
            return $28;
        }))(function () {
            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
        });
    };
    var formInput = function (v) {
        return {
            validators: {
                email: Lunarbox_Form_Validation.emailValidators((dictMonadAff.MonadEffect0()).Monad0()),
                password: Lunarbox_Form_Validation.passwordValidators((dictMonadAff.MonadEffect0()).Monad0())
            },
            initialInputs: Data_Maybe.Nothing.value,
            loginError: Data_Maybe.Nothing.value
        };
    };
    return Formless_Component.component(dictMonadAff)()()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))(Formless_Types_Form.eqInputField(Data_Eq.eqString)))()(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))(Formless_Types_Form.eqInputField(Data_Eq.eqString)))(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))()(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))()(Formless_Internal_Transform.inputFieldsToFormFieldsNil)())())(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))()(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))()(Formless_Internal_Transform.inputFieldsToInputNil)())())(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))()(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))()(Formless_Internal_Transform.nilCountErrors)))(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))()(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))()(Formless_Internal_Transform.nilAllTouched)))(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))()(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))()(Formless_Internal_Transform.setFormFieldsTouchedNil)())())(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedNil)))(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllNil)))(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeLoginForm)()()(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeLoginForm)()()(Formless_Internal_Transform.applyToValidationNil((dictMonadAff.MonadEffect0()).Monad0()))))(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))()(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))()(Formless_Internal_Transform.formFieldsToMaybeOutputNil)())())(Formless_Transform_Row.mkInputFieldsFromRowCons(new Data_Symbol.IsSymbol(function () {
        return "email";
    }))(Formless_Class_Initial.initialString)()(Formless_Transform_Row.mkInputFieldsFromRowCons(new Data_Symbol.IsSymbol(function () {
        return "password";
    }))(Formless_Class_Initial.initialString)()(Formless_Transform_Row.mkInputFieldsFromRowNil)())())(newtypeLoginForm)(newtypeLoginForm)(newtypeLoginForm)(newtypeLoginForm)(newtypeLoginForm)(newtypeLoginForm)(newtypeLoginForm)(newtypeLoginForm)()()()()()()()()()(formInput)({
        render: render,
        handleAction: Formless_Component.defaultSpec.handleAction,
        handleQuery: handleQuery,
        handleEvent: Formless_Component.raiseResult(newtypeLoginForm)(Heterogeneous_Mapping.hmapRecord()(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
            return "email";
        }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
            return "password";
        }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexNil)()())()())),
        receive: Formless_Component.defaultSpec.receive,
        initialize: Formless_Component.defaultSpec.initialize,
        finalize: Formless_Component.defaultSpec.finalize
    });
};
var component = function (dictMonadEffect) {
    return function (dictMonadAff) {
        return function (dictManageUser) {
            return function (dictNavigate) {
                var render = function (v) {
                    return Lunarbox_Page_FormPage.formPage({
                        title: "Welcome back",
                        content: Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                            return "formless";
                        }))(Data_Ord.ordUnit)(Formless_Types_Component["_formless"])(Data_Unit.unit)(formComponent(dictMonadAff))(Data_Unit.unit)(function ($38) {
                            return Data_Maybe.Just.create(HandleLoginForm.create($38));
                        }),
                        message: "Don't have an account?",
                        action: "Register!",
                        onAction: new Data_Maybe.Just(ToRegister.value)
                    });
                };
                var handleAction = function (v) {
                    if (v instanceof HandleLoginForm) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_User.loginUser(Lunarbox_Capability_Resource_User.manageUserHalogenM(dictManageUser))(v.value0))(function (v1) {
                            if (v1 instanceof Data_Either.Left) {
                                return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                    return "formless";
                                }))(Data_Ord.ordUnit)(Formless_Types_Component["_formless"])(Data_Unit.unit)(Formless_Query.injQuery(functorFormQuery)(new SetLoginError(new Data_Maybe.Just(v1.value0), Data_Unit.unit))));
                            };
                            if (v1 instanceof Data_Either.Right) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                    return "formless";
                                }))(Data_Ord.ordUnit)(Formless_Types_Component["_formless"])(Data_Unit.unit)(Formless_Query.injQuery(functorFormQuery)(new SetLoginError(Data_Maybe.Nothing.value, Data_Unit.unit)))))(function () {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (state) {
                                        return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(state.redirect)(Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(Lunarbox_Data_Route.Home.value));
                                    });
                                });
                            };
                            throw new Error("Failed pattern match at Lunarbox.Component.Login (line 58, column 13 - line 63, column 50): " + [ v1.constructor.name ]);
                        });
                    };
                    if (v instanceof ToRegister) {
                        return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(Lunarbox_Data_Route.Register.value);
                    };
                    throw new Error("Failed pattern match at Lunarbox.Component.Login (line 55, column 18 - line 64, column 36): " + [ v.constructor.name ]);
                };
                return Halogen_Component.mkComponent({
                    initialState: Control_Category.identity(Control_Category.categoryFn),
                    render: render,
                    "eval": Halogen_Component.mkEval({
                        handleAction: handleAction,
                        handleQuery: Halogen_Component.defaultEval.handleQuery,
                        receive: Halogen_Component.defaultEval.receive,
                        initialize: Halogen_Component.defaultEval.initialize,
                        finalize: Halogen_Component.defaultEval.finalize
                    })
                });
            };
        };
    };
};
module.exports = {
    component: component,
    LoginForm: LoginForm,
    SetLoginError: SetLoginError,
    newtypeLoginForm: newtypeLoginForm,
    functorFormQuery: functorFormQuery
};
